import { Alert, AlertIcon, Box, Center, Spinner } from "@chakra-ui/react";
import { useState } from "react";
import PageCard from "../../../components/page-card";
import { translate } from "../../../i18n";
import CourtPricingHeatmap from "../../court-details/components/CourtPricingHeatmap";
import { useGetCourtCalendar } from "../../court-details/hooks/useGetCourtCalendar";
import CourtPicker from "./CourtPicker";

export default function CourtPricingManagementList() {
    const [selectedCourt, setSelectedCourt] = useState<number>(0);
    const [dateBoundary] = useState(() => {
        const now = new Date();
        const start = new Date(now.getFullYear(), now.getMonth(), 1);
        const end = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
        return { start, end };
    });

    const { data: courtMonthlyCalendar, isLoading, isError } = useGetCourtCalendar(selectedCourt, dateBoundary.start, dateBoundary.end, selectedCourt > 0);

    return (
        <PageCard title={translate('tabs.court_pricing')}>
            <Box p={4} display="flex" flexDirection="column" gap={4}>
                <CourtPicker
                    selectedCourt={selectedCourt}
                    setSelectedCourt={setSelectedCourt}
                />

                {selectedCourt > 0 && (
                    <Box minH="500px">
                        {isLoading ? (
                            <Center h="500px">
                                <Spinner size="xl" />
                            </Center>
                        ) : isError ? (
                            <Alert status="error">
                                <AlertIcon />
                                {translate('courts.error_loading')}
                            </Alert>
                        ) : courtMonthlyCalendar && (
                            <CourtPricingHeatmap
                                rules={courtMonthlyCalendar.availabilities || []}
                            />
                        )}
                    </Box>
                )}
            </Box>
        </PageCard>
    );
}
